module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('strong', [_vm._v("FOREWORD")])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("lthough there have been many series of commentaries on the English text of the New Testament in recent years, very few attempts have been made to cater particularly to the needs of students of the Greek text. The present initiative to fill this gap by the publication of the "), _c('em', [_vm._v("New International Greek Testament Commentary")]), _vm._v(" is very largely due to the vision of W. Ward Gasque, who was one of the original editors of the series. (The present editors would like to place on record their recognition of Dr. Gasque’s work in the establishment and development of the series until the pressure of other duties made it necessary for him to resign from his editorship). At a time when the study of Greek is being curtailed in many schools of theology, we hope that the "), _c('em', [_vm._v("NIGTC")]), _vm._v(" will demonstrate the continuing value of studying the Greek New Testament and will be an impetus in the revival of such study.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The volumes of of the "), _c('em', [_vm._v("NIGTC")]), _vm._v(" are for students who want something less technical than a full-scale critical commentary. At the same time, the commentaries are intended to interact with modern scholarship and to make their own scholarly contribution to the study of the New Testament. The wealth of detailed study of the New Testament in articles and monographs continues without interruption, and the series is meant to harvest the results of this research in an easily accessible form. The commentaries include, therefore, adequate, but not exhaustive, bibliographies and attempt to treat all important problems of history, exegesis, and interpretation that arise from the New Testament text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of the gains of recent scholarship has been the recognition of the primarily theological character of the books of the New Testament. The volumes of the "), _c('em', [_vm._v("NIGTC")]), _vm._v(" attempt to provide a theological understanding of the text, based on historical-critical-linguistic exegesis. It is not their primary aim to apply and expound the text for modern readers, although it is hoped that the exegesis will give some indication of the way in which the text should be expounded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Within the limits set by the use of the English language, the series aims to be international in character, though the contributors have been chosen not primarily in order to achieve a spread between different countries but above all because of their specialized qualifications for their particular tasks.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("The supreme aim of this series is to serve those who are engaged in the ministry of the Word of God and thus to glorify God’s name. Our prayer is that it may be found helpful in this task.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("I. Howard Marshall"), _c('br'), _vm._v("Donald A. Hagner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-774bdd25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Foreword.vue
// module id = 72
// module chunks = 0